"use strict";

define('app/document/decision/document.decision.view',['require','exports','module','rs/abstract.content.view','redactor','bootstrap-datepicker','rs/helper'],function (require, exports, module) {
  var EVIView = require('rs/abstract.content.view');
  var redactor = require('redactor');
  var datepicker = require('bootstrap-datepicker');
  var helper = require('rs/helper');
  var DocumentDecisionView = EVIView.extend({
    events: {
      'click .rs-navigation-previous': 'handlePreviousNavigationClick',
      'click .save-decision-btn': 'handleSaveDecisionClick',
      'click .edit-decision-btn': 'handleEditDecisionClick',
      'click .cancel-decision-btn': 'handleCancelDecisionClick',
      'click .increase-vote': 'handleVoteIncreaseClick',
      'click .decrease-vote': 'handleVoteDecreaseClick',
      'keypress .number-control': 'handleNumberControlKeypress',
      'change input, select': 'handleInputChange',
      'change .decision-category-checkbox': 'handleDecisionCategoryCheckChange'
    },
    templates: {
      'document.decision.init': 'renderInitFragment',
      'document.decision.categories': 'renderDecisionCategories'
    },
    redactorSettings: {
      buttons: ['bold', 'italic', 'underline', 'deleted', '|', 'unorderedlist', 'orderedlist'],
      minHeight: 150,
      maxHeight: 150,
      autoresize: false,
      tabFocus: false
    },
    initialize: function initialize() {
      this.redactorSettings.changeCallback = this.handleInputChange.proxy(this);
      this._super.apply(this, arguments);
    },
    render: function render() {
      var properties = this.getDelegate().getTemplateProperties();
      this.$el.html(this.renderInitFragment(properties));
      this.setupEditableContent();
    },
    selectTabByName: function selectTabByName(name) {
      var tabContainer = this.$('.tab-container'),
        tabContentContainer = this.$('.tab-content-container'),
        query = '[data-tab="' + name + '"]';
      tabContainer.find('.tab-item').removeClass('active').filter(query).addClass('active');
      return tabContentContainer.find('.tab-content').removeClass('active').filter(query).addClass('active');
    },
    setupTabClasses: function setupTabClasses(el) {
      var edit = this.getDelegate().getEditMode();
      if (edit) {
        el.addClass('edit-mode').removeClass('preview-mode');
      } else {
        el.removeClass('edit-mode').addClass('preview-mode');
      }
    },
    setupEditableContent: function setupEditableContent() {
      var el = this.$el,
        properties = this.getDelegate().getTemplateProperties();
      if (properties.edit) {
        this._initializeFormElements = true;
        el.find('.redactor-input').redactor(this.redactorSettings);
        el.find('.save-decision-btn').show();
        el.find('.edit-decision-btn').hide();
        if (properties.decision) {
          el.find('#document-recused').redactor('set', properties.decision.recused || '');
          el.find('#document-findings').redactor('set', properties.decision.findings || '');
          el.find('#decision-internal-notes').redactor('set', properties.decision.internalNotes || '');
          el.find('#decision-research-notes').redactor('set', properties.decision.researchNotes || '');
        }
        this._initializeFormElements = false;
      }
    },
    refresh: function refresh() {
      var properties = this.getDelegate().getTemplateProperties();
      this.$el.html(this.renderInitFragment(properties));
      this.renderFooter();
      this.setupEditableContent();
      this.resize();
    },
    refreshCategories: function refreshCategories() {
      var properties = this.getDelegate().getTemplateProperties(),
        usesCategories = properties.usesCategories,
        section = this.$('.categories-section');
      if (!usesCategories) {
        section.hide();
      } else {
        section.show();
      }
      section.html(this.renderDecisionCategories(properties));
    },
    showCategoryErrorMessage: function showCategoryErrorMessage() {
      this.$('.category-error-message').removeClass('hide');
    },
    setCategoriesRequired: function setCategoriesRequired(isRequired) {
      var label = this.$('.decision-categories-label');
      if (isRequired) {
        label.addClass('required-text');
      } else {
        label.removeClass('required-text');
      }
    },
    setResultDateRequired: function setResultDateRequired(isRequired) {
      var resultLabel = this.$('.decision-result-date-label');
      if (isRequired) {
        resultLabel.addClass('required-text');
      } else {
        resultLabel.removeClass('required-text');
      }
    },
    setExpirationDateRequired: function setExpirationDateRequired(isRequired) {
      var expirationLabel = this.$('.decision-expiration-date-label');
      if (isRequired) {
        expirationLabel.addClass('required-text');
      } else {
        expirationLabel.removeClass('required-text');
      }
    },
    handleInputChange: function handleInputChange(ev) {
      var el = $(ev.currentTarget),
        property = el.data('property');
      if (property) {
        this.trigger('change:' + property);
      }
      if (!this._initializeFormElements) {
        this.getDelegate().setChangeOccured(true);
      }
    },
    handlePreviousNavigationClick: function handlePreviousNavigationClick() {
      this.getDelegate().requestPreviousNavigation();
    },
    handleSaveDecisionClick: function handleSaveDecisionClick() {
      this.getDelegate().requestSave();
    },
    handleEditDecisionClick: function handleEditDecisionClick() {
      this.getDelegate().requestEdit();
    },
    handleCancelDecisionClick: function handleCancelDecisionClick() {
      this.getDelegate().requestCancel();
    },
    getSelectedCategoryIds: function getSelectedCategoryIds() {
      var checkedCategories = this.$('.decision-category-checkbox:checked');
      return _.map(checkedCategories, function (el) {
        return $(el).data('id');
      });
    },
    handleVoteIncreaseClick: function handleVoteIncreaseClick(ev) {
      this.handleInputChange(ev);
      var el = this.getInputElementFromVote(ev),
        num = parseInt(el.val()) || 0;
      if (num < 99) {
        el.val(num + 1);
      }
    },
    handleVoteDecreaseClick: function handleVoteDecreaseClick(ev) {
      this.handleInputChange(ev);
      var el = this.getInputElementFromVote(ev),
        num = parseInt(el.val()) || 0;
      el.val(Math.max(0, num - 1));
    },
    handleNumberControlKeypress: function handleNumberControlKeypress(ev) {
      var keyCode = window.event ? ev.keyCode : ev.which;
      if (keyCode < 48 || keyCode > 57) {
        if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
          ev.preventDefault();
        }
      }
    },
    getInputElementFromVote: function getInputElementFromVote(ev) {
      return $(ev.currentTarget).parent().find('input');
    },
    getRichInputData: function getRichInputData(sel) {
      var redactor = this.$(sel).data('redactor'),
        value = '';
      if (redactor) {
        value = redactor.get() || '';
      }
      return value;
    },
    getInputDate: function getInputDate(sel) {
      var el = this.$(sel);
      if (String(el.val()).length) {
        return el.datepicker('getDate');
      }
      return null;
    },
    getDecisionTypeId: function getDecisionTypeId() {
      return this.$('#decision-type').val();
    },
    getResultDate: function getResultDate() {
      return this.getInputDate('#decision-result-date');
    },
    setExpirationDate: function setExpirationDate(date) {
      var el = this.$('#decision-expiration-date');
      el.datepicker('setDate', date);
      return el;
    },
    setExpirationDateEnabled: function setExpirationDateEnabled(enabled) {
      var expDate = this.$('#decision-expiration-date');
      expDate.prop('disabled', !enabled);
      if (!enabled) {
        expDate.val('');
      }
    },
    getExpirationDate: function getExpirationDate() {
      return this.getInputDate('#decision-expiration-date');
    },
    getVoteFor: function getVoteFor() {
      return Number(this.$('#decision-vote-for').val());
    },
    getVoteAgainst: function getVoteAgainst() {
      return Number(this.$('#decision-vote-against').val());
    },
    getVoteAbstain: function getVoteAbstain() {
      return Number(this.$('#decision-vote-abstain').val());
    },
    getRecused: function getRecused() {
      return this.getRichInputData('#document-recused');
    },
    getFindings: function getFindings() {
      return this.getRichInputData('#document-findings');
    },
    getInternalNotes: function getInternalNotes() {
      return this.getRichInputData('#decision-internal-notes');
    },
    getResearchNotes: function getResearchNotes() {
      return this.getRichInputData('#decision-research-notes');
    },
    showExpirationDateSuccess: function showExpirationDateSuccess() {
      this.$('.decision-expiration-date-error').slideUp();
    },
    showExpirationDateError: function showExpirationDateError(str) {
      this.$('.decision-expiration-date-error .error-message').text(str);
      this.$('.decision-expiration-date-error').slideDown();
    },
    showResultDateError: function showResultDateError(str) {
      this.$('.decision-result-date-error .error-message').text(str);
      this.$('.decision-result-date-error').slideDown();
    },
    showResultDateSuccess: function showResultDateSuccess() {
      this.$('.decision-result-date-error').slideUp();
    },
    showCategoriesError: function showCategoriesError(str) {
      this.$('.decision-categories-error .error-message').text(str);
      this.$('.decision-categories-error').slideDown();
    },
    showCategoriesSuccess: function showCategoriesSuccess() {
      this.$('.decision-categories-error').slideUp();
    },
    getLetterTableElement: function getLetterTableElement() {
      return this.$('.letter-table-container');
    }
  });
  module.exports = DocumentDecisionView;
});

